import { flexRender } from "@tanstack/react-table";
import { size } from "lodash";
import { Key } from "react";

interface Props {
  table: any;
  className?: string;
  emptyRecordMsg?: string;
  isLoading?: boolean;
  loadingMsg?: string;
}

const Table = ({
  table,
  className = "",
  emptyRecordMsg,
  isLoading = false,
  loadingMsg = "fetching...",
}: Props) => {
  return (
    <div className={`relative h-full rounded-md overflow-x-auto${className}`}>
      <table className="w-full">
        <thead className="bg-white px-6 py-3 rounded-md ">
          {table
            .getHeaderGroups()
            .map(
              (headerGroup: { id: Key | null | undefined; headers: any[] }) => (
                <tr key={headerGroup.id} className="border-b border-[#84848c]">
                  {headerGroup.headers.map(
                    (header: {
                      id: Key | null | undefined;
                      colSpan: number | undefined;
                      isPlaceholder: any;
                      column: { columnDef: { header: any } };
                      getContext: () => any;
                    }) => (
                      <th
                        key={header.id}
                        colSpan={header.colSpan}
                        className="px-5 py-2 text-left text-sm"
                      >
                        {header.isPlaceholder
                          ? null
                          : flexRender(
                              header.column.columnDef.header,
                              header.getContext(),
                            )}
                      </th>
                    ),
                  )}
                </tr>
              ),
            )}
        </thead>
        <tbody className="rounded-md">
          {!isLoading &&
            size(table.getRowModel().rows) > 0 &&
            table
              .getRowModel()
              .rows.map(
                (row: {
                  id: Key | null | undefined;
                  getVisibleCells: () => any[];
                }) => (
                  <tr key={row.id} className="border-b border-[#84848c]">
                    {row
                      .getVisibleCells()
                      .map(
                        (cell: {
                          id: Key | null | undefined;
                          column: { columnDef: { cell: any } };
                          getContext: () => any;
                        }) => (
                          <td
                            key={cell.id}
                            className="px-5 py-[6px] text-left text-[13px]"
                          >
                            {flexRender(
                              cell.column.columnDef.cell,
                              cell.getContext(),
                            )}
                          </td>
                        ),
                      )}
                  </tr>
                ),
              )}
        </tbody>
      </table>
      {isLoading && (
        <div className="bg-white rounded drop-shadow-2xl text-lg font-medium absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-30 p-3">
          <span>{loadingMsg}</span>
        </div>
      )}
      {/* {isLoading && (
        <div className="flex justify-center mt-5">
          <span>{loadingMsg}</span>
        </div>
      )} */}
      {!isLoading && size(table.getRowModel().rows) <= 0 && (
        <div className="flex justify-center my-5">
          <span>{emptyRecordMsg}</span>
        </div>
      )}
    </div>
  );
};

export default Table;
